import { useNavigate } from "react-router-dom"
import {
    ThemeProvider
} from "@mui/material"

import { customTheme, MetricHeaderMid, MetricHeaderLeft, MetricHeaderRight, MetricHeaderWrapper } from "../Atom"
import { HeaderInfoNav } from "../Reusable"

export default function GroupProfileHeader({ name }: any) {

    const navigate = useNavigate()

    const handleClickBack = (e: any) => {
        navigate(-1)
    }

    return (
        <>
            <ThemeProvider theme={customTheme}>
                <MetricHeaderWrapper>

                    <MetricHeaderLeft>
                        <HeaderInfoNav name={name} handleClickBack={handleClickBack} />
                    </MetricHeaderLeft>


                    <MetricHeaderMid>
                    </MetricHeaderMid>


                    <MetricHeaderRight>
                    </MetricHeaderRight>

                </MetricHeaderWrapper>
            </ThemeProvider>
        </>
    )
}
